/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgBolt = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M12 .586 23.414 12 12 23.414.586 12zM3.414 12 12 20.586 20.586 12 12 3.414zm8.729-5.514 1.715 1.029L11.766 11h4l-3.908 6.514-1.715-1.029L12.234 13h-4z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgBolt as Bolt };
